export default __webpack_public_path__ + "static/media/ic-crops-coriander.44a6f5a0.svg";